import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import '../../../../styles/scss/style.css';

//Components
import TextHeadingOne from '../../atoms/TextHeadingOne';
import TextParagraph from '../../atoms/TextParagraph';
import FormButton from '../../atoms/FormButton';
import Modal from '../Modal';
import { ROOT_URL } from '../../../config/global.js';
import { strings } from './FormDeleteSubjectContent';

//Returning the component
class FormDeleteBot extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedSubject: {},
			loading: false
		}
		
		this.deleteSubjectHandler = this.deleteSubjectHandler.bind(this);
	}
	componentWillReceiveProps(nextProps) {
		this.setState({ selectedSubject: nextProps.selectedSubject });
	}
	deleteSubjectHandler(e) {
		e.preventDefault();

		// Adding loading state to store
		this.props.loading(true);

		const deleteSubjectRequest = axios({
            method: 'delete',
            url: `${ROOT_URL}/api/subjects/${this.state.selectedSubject._id}`
        });

        deleteSubjectRequest.then( (subjectReqAnswer) => {
			var newItem = subjectReqAnswer.data;
			newItem.type = 'loaded';
			this.props.setSelectedSubject(newItem); // Clears the selectedSubject with the new one

			this.props.fetchCurrentBot(this.props.match.params.id);

			this.props.loading(false); // Removing loading screen
        });
	}
	render() {
		return (
			<Modal modalClass={this.props.modalClass} onClick={this.props.onClickCancel}>
				<form className={`form formDeleteBot ${this.props.formWrapperClassType}`}>
					<TextHeadingOne text={strings.heading} />
					<TextParagraph text={strings.paragraph} />
					<div className="formDeleteBot__infoBox">
						<div className="formDeleteBot__info">
							<TextParagraph classType="formDeleteBot__data" text={strings.paragraph2} />
							<TextParagraph text={this.state.selectedSubject ? this.state.selectedSubject.name : ''} />
						</div>
					</div>
					<div className="btnRow">
					<FormButton text={strings.button.text} onClick={(e) => this.deleteSubjectHandler(e)} />
					<FormButton text={strings.button.textCancel} onClick={this.props.onClickCancel} />
					</div>
				</form>
			</Modal>
		)
	}
}

//Making sure that it has a text property when it's declared
FormDeleteBot.propTypes = {
	sectionType: PropTypes.string,
	TextHeadingTwoText: PropTypes.string,
	paragraphText: PropTypes.string,
	buttonText: PropTypes.string
}

export default withRouter(FormDeleteBot);


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormDeleteSubject/FormDeleteSubject.jsx